export default __webpack_public_path__ + "static/media/thumbchar.8494dbf8.png";